module.exports = __webpack_public_path__ + "img/avatar.48e25180.svg";